import Modal from '@/customComponents/uiComponents/modal/Modal.jsx'
import ModalHeader from '@/customComponents/uiComponents/modal/ModalHeader.jsx'
import {flightDelayIcon, infinityIcon} from '@img/index.js'

export default function FlightDelayedPopup({isOpen, onClose}) {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalHeader title="Flight Delayed? No Problem" onClose={onClose}/>
            <div className="bg-(--accent-green-light) p-5 mb-3">
                <h5 className="font-semibold mb-3!">Flight Delayed? No Problem:</h5>
                <div className="flex items-start gap-3">
                    <img src={flightDelayIcon} alt="" className="w-6 h-6 shrink-0 mt-0.5"/>
                    <span className="text-sm leading-relaxed">Hop'n tracks your flight and adjusts your pickup time automatically. Whether it's a flight delay or baggage hold-up, we've got you covered. Simply choose "By flight arrival" and let your navigator ensure a smooth pickup experience</span>
                </div>
            </div>
            <div className="bg-(--bg-grey) rounded-2xl p-5">
                <h5 className="font-semibold mb-3!">Lost baggage or delays</h5>
                <div className="flex items-start gap-3">
                    <img src={infinityIcon} alt="" className="w-6 h-6 shrink-0 mt-0.5"/>
                    <span className="text-sm leading-relaxed">Lost baggage? Customs or immigration delays? No worries—your driver will wait as long as needed</span>
                </div>
            </div>
        </Modal>
    )
}
